import { useSelector } from 'react-redux';
import { selectTranslationLanguages } from '@rsos/reduxDataStore/src/features/chats/chatsSlice';
import { TranslationLanguage } from '@rsos/reduxDataStore/src/features/chats/chatsTypes';

export type LanguageOption = {
  value: string;
  label: string;
  data: TranslationLanguage;
};

export function useTranslationLanguageOptions(
  detectedLanguage?: string,
): LanguageOption[] {
  const languageList = useSelector(selectTranslationLanguages);
  return languageList.map(language => ({
    value: language.languageCode,
    label: `${language.languageDisplayName}${
      language.languageCode === detectedLanguage ? ' (auto-detected)' : ''
    }`,
    data: language,
  }));
}
